<template>
  <div v-if="jobs.length" class="block">
    <job-list-item v-for="job in jobs" :key="job.id" :job="job" />
  </div>
</template>

<script>
import JobListItem from './JobListItem'

export default {
  components: { JobListItem },
  data () {
    return {
      jobs: []
    }
  },
  watch: {
    jobs (val) {
      if (val.length) {
        this.startPoller()
      } else {
        this.stopPoller()
      }
    }
  },
  methods: {
    load () {
      this.$api.getJobs().then((result) => {
        this.jobs = result.data
      })
    },
    startPoller () {
      this.stopPoller()
      this.poller = setInterval(() => {
        this.load()
      }, 5000) // poll every 5 seconds
    },
    stopPoller () {
      clearInterval(this.poller)
    }
  },
  created () {
    this.load()
  },
  beforeDestroy () {
    this.stopPoller()
  }
}
</script>



// WEBPACK FOOTER //
// JobList.vue?4909e68e